module.exports = __webpack_public_path__ + "assets/b1dc8184cac81612bbacba7c6a68a38e.png";